import React, { FC, useState } from 'react';

import { Collapse } from '../../../../../../ReactSharedScripts/components/Collapse';
import classNames from 'classnames';
import { ThemeStyle } from '../../../../../../ReactSharedScripts/utils/const';
import { TooltipLanguageItem } from './TooltipLanguageItem';
import classes from './styles/index.module.scss';
import {
	ClickOnHTMLAnchorFunction,
	TooltipLanguageCollapseItemProps,
} from 'modules/header/components/HeaderUserTooltip/types';

const TooltipLanguageCollapseItem: FC<TooltipLanguageCollapseItemProps> = ({ collapsedItems, image, name, theme }) => {
	const [isOpened, setIsOpened] = useState(false);
	const toggleCollapse: ClickOnHTMLAnchorFunction = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setIsOpened(!isOpened);
	};
	const tooltipSplitterClassNames = classNames(classes.tooltipSplitter, {
		[classes.tooltipSplitter_light]: theme === ThemeStyle.Light,
		[classes.tooltipSplitter_dark]: theme === ThemeStyle.Dark,
	});

	if (collapsedItems.length === 0) {
		return null;
	}

	return (
		<>
			<hr className={tooltipSplitterClassNames} />
			<TooltipLanguageItem
				image={image}
				name={name}
				theme={theme}
				isOpened={isOpened}
				itemClick={toggleCollapse}
				hasCollapse
			/>
			<Collapse isOpened={isOpened}>
				{collapsedItems.map((item) => (
					<TooltipLanguageItem
						{...item}
						key={item.languageCode}
						image={item.icon}
						theme={theme}
						isDirtyLink
					/>
				))}
			</Collapse>
		</>
	);
};

export { TooltipLanguageCollapseItem };
